<script>
import MetisMenu from "metismenujs/dist/metismenujs";
import { authComputed, authMethods } from "@/state/helpers";
import { menuItems } from "./menu";
import { mapGetters } from "vuex";
/**
 * Sidenav component
 */
export default {
  data() {
    return {
      menuItems: menuItems,
      menuData: null,
    };
  },
  mounted: function () {
    // eslint-disable-next-line no-unused-vars
    var menuRef = new MetisMenu("#side-menu");
    var links = document.getElementsByClassName("side-nav-link-ref");
    var matchingMenuItem = null;
    const paths = [];

    for (var i = 0; i < links.length; i++) {
      paths.push(links[i]["pathname"]);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf("/");
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add("active");
      var parent = matchingMenuItem.parentElement;

      /**
       * TODO: This is hard coded way of expading/activating parent menu dropdown and working till level 3.
       * We should come up with non hard coded approach
       */
      if (parent) {
        parent.classList.add("mm-active");
        const parent2 = parent.parentElement.closest("ul");
        if (parent2 && parent2.id !== "side-menu") {
          parent2.classList.add("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.add("mm-active");
            var childAnchor = parent3.querySelector(".has-arrow");
            var childDropdown = parent3.querySelector(".has-dropdown");
            if (childAnchor) childAnchor.classList.add("mm-active");
            if (childDropdown) childDropdown.classList.add("mm-active");

            const parent4 = parent3.parentElement;
            if (parent4 && parent4.id !== "side-menu") {
              parent4.classList.add("mm-show");
              const parent5 = parent4.parentElement;
              if (parent5 && parent5.id !== "side-menu") {
                parent5.classList.add("mm-active");
                const childanchor = parent5.querySelector(".is-parent");
                if (childanchor && parent5.id !== "side-menu") {
                  childanchor.classList.add("mm-active");
                }
              }
            }
          }
        }
      }
    }
  },
  methods: {
    /**
     * Returns true or false if given menu item has child or not
     * @param item menuItem
     */
    ...authMethods,
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },

    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle("mm-show");
    },
    logoutUser() {
      // eslint-disable-next-line no-unused-vars
      this.logout().then(() => this.$router.push({ name: "landing" }));
    },

    userCan(route) {
      const allowedRoutes = ["dashboard", "quote", "profile"];
      if (allowedRoutes.includes(route)) {
        return true;
      } else {
        return this.contracted;
      }
    },

    userPermissions(route) {
      const menuitems = this.menuItems.map((item) => {
        return item.id;
      });
      const permissions = this.account.permissions.map((x) =>
        x.toLowerCase().replace("manage ", "")
      );
      permissions.push("dashboard", "profile");
      const output = permissions.filter((item) => menuitems.includes(item));
      if (output.includes(route) && this.user.is_owner == false) {
        return true;
      } else if (this.user.is_owner == true) {
        return this.contracted;
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapGetters({
      contracted: ["auth/userPermission"],
      freight: ["auth/freight"],
      account: ["auth/account"],
    }),
  },
};
</script>

<template>
  <!-- ========== Left Sidebar Start ========== -->
  <div>
    <!--- Sidemenu -->
    <div class="navbar-brand-box test-box">
      <router-link to="/" class="logo logo-dark">
        <span class="logo-sm">
          <img :src="isRtl
              ? require('../assets/WeStore_logo-white-footer-arabic-w208.png')
              : require('@/assets/images/logo-dark.png')
            " alt height="17" />
        </span>
        <span class="logo-lg">
          <img :src="isRtl
              ? require('../assets/WeStore_logo-white-footer-arabic-w208.png')
              : require('@/assets/images/logo-dark.png')
            " alt height="17" />
        </span>
      </router-link>

      <router-link to="/" class="logo logo-light">
        <span class="logo-sm">
          <img :src="isRtl
              ? require('../assets/WeStore_logo-white-footer-arabic-w208.png')
              : require('@/assets/images/logo-light.png')
            " alt height="50" />
        </span>
        <span class="logo-lg">
          <img :src="isRtl
              ? require('../assets/WeStore_logo-white-footer-arabic-w208.png')
              : require('@/assets/images/logo-light.png')
            " alt height="50" />
        </span>
      </router-link>
    </div>
    <div id="sidebar-menu">
      <!-- Left Menu Start -->

      <ul id="side-menu" class="list-unstyled pl-1">
        <template v-for="item in menuItems">
          <!-- <li class="menu-title" v-if="item.isTitle" :key="item.id">
          {{ $t(item.label) }}
        </li> -->
          <li v-if="!item.isTitle && !item.isLayout" :key="item.id" class="side-nav__item">
            <!-- <a
            v-if="hasItems(item)"
            href="javascript:void(0);"
            class="is-parent side-nav__link"
            :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }"
          >
            <img class="mr-2" :src="item.icon" :height="item.height" />
             <i :class="`bx ${item.icon}`" v-if="item.icon"></i> 
            <span class="icon pt-1">{{ $t(item.label) }}</span>
          </a> -->

            <router-link v-if="!hasItems(item) && userCan(item.id) && userPermissions(item.id)
              " :to="item.link" class="side-nav-link-ref side-nav__item__link d-flex align-items-center"
              :exact="item.id === 'dashboard' && true" active-class="side-nav__item__link--active">
              <img :class="isRtl ? 'ml-3' : 'mr-3'" :src="item.icon" alt :height="item.height" />
              <!-- <i :class="`bx ${item.icon}`" v-if="item.icon"></i> -->
              <span>{{ $t(item.label) }}</span>
            </router-link>

            <!-- <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
                    <li v-for="(subitem, index) of item.subItems" :key="index">
                        <router-link :to="subitem.link" v-if="!hasItems(subitem)" class="side-nav-link-ref">{{ $t(subitem.label) }}</router-link>
                        <a v-if="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);">{{ $t(subitem.label) }}</a>
                        <ul v-if="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                            <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                                <router-link :to="subSubitem.link" class="side-nav-link-ref">{{ $t(subSubitem.label) }}</router-link>
                            </li>
                        </ul>
                    </li>
                </ul> -->
          </li>
        </template>
        <!--freight-tab-->
        <li v-if="freight" class="side-nav__item">
          <router-link :to="{ name: 'insights' }" class="side-nav-link-ref side-nav__item__link d-flex align-items-center"
            exact-active-class="side-nav__item__link--active">
            <img :class="isRtl ? 'ml-3' : 'mr-2'" src="../assets/icons/SVG/insights.png" height="22" />
            <span class="icon pt-1">{{ $t("insights") }} </span>
          </router-link>
        </li>

        <li v-if="freight" class="side-nav__item">
          <router-link :to="{ name: 'freights-list' }"
            class="side-nav-link-ref side-nav__item__link d-flex align-items-center"
            exact-active-class="side-nav__item__link--active">
            <img :class="isRtl ? 'ml-3' : 'mr-2'" src="../assets/icons/SVG/freight-shipping.png" height="22" />
            <span class="icon pt-1">{{ $t("freight") }} </span>
          </router-link>
        </li>


        <li @click.prevent="logoutUser" class="side-nav__item">
          <a class="side-nav-link-ref side-nav__item__link">
            <img :class="isRtl ? 'ml-3' : 'mr-2'" src="../assets/icons/SVG/Logout white.svg" height="22" />
            <span class="icon pt-1">{{ $t("Logout") }} </span>
          </a>
        </li>
      </ul>
    </div>
    <!-- Sidebar -->
  </div>
</template>
<style scoped lang="scss">
.test-box {
  height: 100px;
}

.icon {
  display: inline-block;
}

.side-nav__item {
  margin-block: 5px;

  &__link {
    &--active {
      // background:rgb(221,23,61);
      background: #e33064;

      &:hover span {
        color: #fff !important;
      }
    }

    span {
      font-size: 0.95rem;
      display: inline-block !important;
      padding-left: 0 !important;
      transition: all 0.1s ease-in-out;
    }

    &:hover span {
      color: #e83e8c;
    }
  }

  &__item:active::before {
    background-color: var(--color-Primary-light);
  }
}
</style>
